import Svg from 'components/utilities/svg'

const UndoIcon = ({ ...props }) => (
  <Svg viewBox="0 0 16 15" {...props}>
    <title>Undo Icon</title>
    <path d="M3.41663 14.4166V12.5833H9.92496C10.8875 12.5833 11.7239 12.2777 12.4343 11.6666C13.1448 11.0555 13.5 10.2916 13.5 9.37496C13.5 8.45829 13.1448 7.6944 12.4343 7.08329C11.7239 6.47218 10.8875 6.16663 9.92496 6.16663H4.14996L6.53329 8.54996L5.24996 9.83329L0.666626 5.24996L5.24996 0.666626L6.53329 1.94996L4.14996 4.33329H9.92496C11.4069 4.33329 12.6788 4.81454 13.7406 5.77704C14.8024 6.73954 15.3333 7.93885 15.3333 9.37496C15.3333 10.8111 14.8024 12.0104 13.7406 12.9729C12.6788 13.9354 11.4069 14.4166 9.92496 14.4166H3.41663Z" />
  </Svg>
)

UndoIcon.displayName = 'Undo'

export default UndoIcon
